import { useNavigate, useLocation } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";

/**
 * Slim page header for desktop — page title + back button on chantier detail.
 * Sits at the top of the main content area (sidebar handles branding + search).
 */
export default function DesktopPageHeader({ title, subtitle, right }) {
  const nav = useNavigate();
  const loc = useLocation();
  const showBack = loc.pathname.startsWith("/chantiers/") && loc.pathname !== "/chantiers";

  return (
    <header
      className="hidden lg:flex sticky top-0 z-10 h-14 items-center justify-between px-6 lg:px-8 border-b border-white/8 bg-[#0A0A0A]/70 backdrop-blur-md"
      data-testid="desktop-page-header"
    >
      <div className="flex items-center gap-3 min-w-0">
        {showBack && (
          <button
            onClick={() => nav(-1)}
            className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 flex items-center justify-center"
            data-testid="desktop-back-btn"
            title="Retour"
          >
            <CaretLeft size={16} weight="bold" />
          </button>
        )}
        <div className="min-w-0">
          <div className="font-display font-bold text-lg leading-tight truncate">{title}</div>
          {subtitle && <div className="text-[10px] uppercase tracking-widest text-white/40 leading-tight">{subtitle}</div>}
        </div>
      </div>
      {right && <div className="flex items-center gap-2">{right}</div>}
    </header>
  );
}
